import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { CheckList } from '../CheckList';
import { volumes } from '../../data/volumes';
import { collectionChecks, images } from '../../data/offer';
export function Volumes() {
  const [open, setOpen] = useState<string | null>('I');
  return <section className="w-full bg-white px-4 py-16 sm:px-6 lg:py-24" aria-labelledby="volumes-title" data-id="element-281" data-mp="2o2eq16j5f88u">
      <div className="mx-auto max-w-4xl" data-id="element-282" data-mp="2j822olejxcrt">
        <SectionHeading title={<span id="volumes-title" data-id="element-284" data-mp="2eb1y6excoi2t">The 6-Volume Clear Aligner Clinical Blueprint™ Collection</span>} subtitle="Six coordinated digital volumes covering the major stages of clear aligner case assessment, planning, review, and reassessment." data-id="element-283" data-mp="2ebttrpqy6ft3" />

        <img src={images.mockup} alt="All six volumes of the Clear Aligner Clinical Blueprint" className="-mx-4 mt-8 w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-2xl" data-id="element-285" data-mp="20ar3t1wu0lcw" />

        <div className="mt-8 space-y-4" data-id="element-286" data-mp="37ww2k657jevv">
          {volumes.map(v => {
          const isOpen = open === v.n;
          return <article key={v.n} className="overflow-hidden rounded-3xl bg-white ring-1 ring-navy/10" data-id="element-287" data-mp="2u6iv04w8a272">
                <div className="h-2 w-full" style={{
              backgroundColor: v.color
            }} aria-hidden="true" data-id="element-288" data-mp="2y72pf0pf2rpi" />
                <div className="p-5 sm:p-7" data-id="element-289" data-mp="3lwnem1c5yl78">
                  <p className="font-display text-sm font-extrabold uppercase" style={{
                color: v.color
              }} data-id="element-290" data-mp="3quyk5zvfe9jn">
                    Volume {v.n}
                  </p>
                  <h3 className="mt-1 text-balance font-display text-xl font-extrabold leading-tight text-navy sm:text-2xl" data-id="element-291" data-mp="3cv5vea3gm3eb">{v.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-muted sm:text-base" data-id="element-292" data-mp="21gjzprrfx8ty">{v.intro}</p>

                  <button type="button" onClick={() => setOpen(isOpen ? null : v.n)} aria-expanded={isOpen} className="mt-4 flex w-full items-center justify-between gap-3 rounded-xl bg-[#F6F8FC] px-4 py-3 text-left text-sm font-bold text-navy transition-colors duration-150 ease-out hover:bg-brand-50 sm:text-base" data-id="element-293" data-mp="26fwowj5sarzp">
                    <span data-id="element-294" data-mp="3uc34z8scc1sx">Inside this volume ({v.items.length} resources)</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-295" data-mp="3pektpbqupahr" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-296" data-mp="3fg597rmbwzh8">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-297" data-mp="3bfuw7v04d8sv">
                        <ul className="grid gap-2.5 pt-4 sm:grid-cols-2" data-id="element-298" data-mp="2wilc0ev32ldi">
                          {v.items.map(it => <li key={it} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink" data-id="element-299" data-mp="31b51a934v4y5">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                        color: v.color
                      }} strokeWidth={3} aria-hidden="true" data-id="element-300" data-mp="35e1axaap3qpy" />
                              {it}
                            </li>)}
                        </ul>
                      </motion.div>}
                  </AnimatePresence>

                  <p className="mt-4 border-l-4 pl-3 text-sm leading-relaxed text-ink-muted" style={{
                borderColor: v.color
              }} data-id="element-301" data-mp="2mmianb822qrm">
                    <strong className="text-navy" data-id="element-302" data-mp="3t19hrwnrv7u3">Purpose:</strong> {v.purpose}
                  </p>
                </div>
              </article>;
        })}
        </div>

        <div className="mt-10 rounded-3xl bg-brand-50 p-5 sm:p-8" data-id="element-303" data-mp="eu8uewwkcwj">
          <h3 className="text-center font-display text-lg font-extrabold uppercase text-navy sm:text-xl" data-id="element-304" data-mp="3rkvnsyjznqng">Your complete collection includes:</h3>
          <div className="mx-auto mt-5 max-w-2xl" data-id="element-305" data-mp="9gajmnrmqh1a">
            <CheckList items={collectionChecks} columns={2} data-id="element-306" data-mp="5cmcg66wtngk" />
          </div>
        </div>

        <CtaButton label="Yes! Send me the 6 volumes" className="mt-8" data-id="element-307" data-mp="jcnc5ibfuoug" />
      </div>
    </section>;
}